export default __webpack_public_path__ + "static/media/race-conferences.aa4e8283.jpg";